import { AriseFeesFields } from "./ariseFeesFields";

export const AriseFeesTemplateFields = {
	IsDefault: {
		name: "is_default",
		displayName: "Default Fee Template",
	},
	Status: {
		name: "is_active",
		displayName: "Status",
	},
	TemplateName: {
		name: "name",
		displayName: "Template Name",
	},
	PlatformSetupFee: {
		name: "platform_setup_fee",
		displayName: AriseFeesFields.PlatformSetupFee.displayFullName,
	},
	PlatformMonthlyFee: {
		name: "platform_monthly_fee",
		displayName: AriseFeesFields.PlatformMonthlyFee.displayFullName,
	},
	CustomerVaultMonthlyFee: {
		name: "customer_vault_monthly_fee",
		displayName: AriseFeesFields.CustomerVaultMonthlyFee.displayFullName,
	},
	EnhancedDataTransactionFee: {
		name: "l2_l3_enhanced_data_transaction_fee",
		displayName: AriseFeesFields.EnhancedDataTransactionFee.displayFullName,
	},
	CardTransactionAuthorizationFee: {
		name: "card_transaction_and_authorization_fee",
		displayName:
			AriseFeesFields.CardTransactionAuthorizationFee.displayFullName,
	},
	ECommercePluginSetupFee: {
		name: "e_commerce_plugin_setup_fee",
		displayName: AriseFeesFields.ECommercePluginSetupFee.displayFullName,
	},
	ECommercePluginMonthlyFee: {
		name: "e_commerce_plugin_monthly_fee",
		displayName: AriseFeesFields.ECommercePluginMonthlyFee.displayFullName,
	},
	EMVDeviceSetupFee: {
		name: "emv_device_setup_fee",
		displayName: AriseFeesFields.EMVDeviceSetupFee.displayFullName,
	},
	AdditionalEmvDeviceMonthlyFee: {
		name: "additional_emv_device_monthly_fee",
		displayName:
			AriseFeesFields.AdditionalEmvDeviceMonthlyFee.displayFullName,
		sign: AriseFeesFields.AdditionalEmvDeviceMonthlyFee.sign,
	},
	EnhancedDataSetupFee: {
		name: "l2_l3_enhanced_data_setup_fee",
		displayName: AriseFeesFields.EnhancedDataSetupFee.displayFullName,
	},
	CustomerVaultSetupFee: {
		name: "customer_vault_setup_fee",
		displayName: AriseFeesFields.CustomerVaultSetupFee.displayFullName,
	},
	CustomerVaultAutomaticUpdateFee: {
		name: "cstomer_vault_automatic_update_fee",
		displayName:
			AriseFeesFields.CustomerVaultAutomaticUpdateFee.displayFullName,
	},
	MobileInvoicingPaymentsSetupFee: {
		name: "mobile_invoicing_and_payments_setup_fee",
		displayName:
			AriseFeesFields.MobileInvoicingPaymentsSetupFee.displayFullName,
		sign: AriseFeesFields.MobileInvoicingPaymentsSetupFee.sign,
	},
	MobileInvoicingPaymentsMonthlyFee: {
		name: "mobile_invoicing_and_payments_monthly_fee",
		displayName:
			AriseFeesFields.MobileInvoicingPaymentsMonthlyFee.displayFullName,
		sign: AriseFeesFields.MobileInvoicingPaymentsMonthlyFee.sign,
	},
	MobileInvoicingPaymentsMessageFee: {
		name: "mobile_invoicing_and_payments_message_fee",
		displayName:
			AriseFeesFields.MobileInvoicingPaymentsMessageFee.displayFullName,
		sign: AriseFeesFields.MobileInvoicingPaymentsMonthlyFee.sign,
	},
	CardNetworkTokenizationToggle: {
		name: "tsys_tokenization",
		displayName: "Card Network Tokenization",
	},
	CardNetworkTokenizationSetupFee: {
		name: "card_network_tokenization_setup_fee",
		displayName:
			AriseFeesFields.CardNetworkTokenizationSetupFee.displayFullName,
	},
	CardNetworkTokenizationMonthlyFee: {
		name: "card_network_tokenization_monthly_fee",
		displayName:
			AriseFeesFields.CardNetworkTokenizationMonthlyFee.displayFullName,
	},
	CardNetworkTokenizationPerItemFee: {
		name: "card_network_per_tokenization_event_fee",
		displayName: "Per Item Fee",
	},
};
